import { App } from 'vue'
import KIcon from './src/icon.vue'

KIcon.install = (app: App): void => {
  app.component(KIcon.name, KIcon)
}

export default KIcon
